import React, { useEffect, useState } from 'react';
import 'whatwg-fetch';

import ModalConfirm from '../components/modal/modalConfirm';

import hardwareIcon from '../../images/icons/hardware.svg';
import virtualIcon from '../../images/icons/virtual.svg';
import SubNavBar from '../components/SubNavBar';
import { Box } from '@material-ui/core';
import QuoteVirtual from './components/QuoteVirtual';
import QuoteHardware from './components/QuoteHardware';
import useStepProduction from './hooks/useStepProduction';
import Timeline from './components/Timeline';

const AppProduction = ({
  history,
  openToast,
  toggleBlackOut,
  match: {
    params: { id: dealId },
  },
}) => {
  const [textModal, setTextModal] = useState<{ title?: string; message?: string }>({
    title: undefined,
    message: undefined,
  });
  const [selectedView, setSelectedView] = useState(1);
  const [currentStep, setCurrentStep] = useState(1);
  const [dataQuoteHardware, setDataQuoteHardware] = useState<
    { id: number; quantity?: number; productReference?: any; delivered?: boolean; waitingSupplier?: boolean }[]
  >();
  const [dataQuoteVirtual, setDataQuoteVirtual] = useState<
    { id: number; quantity?: number; productReference?: any; delivered?: boolean; waitingSupplier?: boolean }[]
  >();
  const [quoteStateChangeId, setQuoteStateChangeId] = useState<number>();
  const [quoteStateChangeNewState, setQuoteStateChangeNewState] = useState<string>();
  const [isModalQuoteStateChangeOpen, setIsModalQuoteStateChangeOpen] = useState(false);
  const [inStockHardware, setInStockHardware] = useState<{ inStock: boolean; reference?: { id?: number } }[]>();

  const { getQuoteArticles, updateQuote, updateDealOrderStepNumber } = useStepProduction();

  useEffect(() => {
    syncData();
  }, []);

  useEffect(() => {
    syncData();
  }, [dealId]);

  const syncData = async () => {
    if (dealId) {
      const { inStockHardware, quoteHardware, quoteVirtual, intermediateStageNumber } = await getQuoteArticles(dealId);

      setCurrentStep(intermediateStageNumber);
      setInStockHardware(inStockHardware);
      setDataQuoteHardware(quoteHardware);
      setDataQuoteVirtual(quoteVirtual);
    }
  };

  const getStockQuantity = (refId: number): number => {
    let nbProductStock = 0;
    for (let i = 0; i < (inStockHardware?.length || 0); i++) {
      const hardware = inStockHardware![i];
      if (hardware.inStock && hardware.reference?.id == refId) {
        nbProductStock++;
      }
    }

    return nbProductStock;
  };

  const openModalChangeQuoteState = (quoteId: number, newState: string) => {
    setTextModal({
      title: 'Etat commande',
      message: 'Vous allez modifiez l\'état en "' + newState + '"',
    });
    toggleBlackOut();
    setIsModalQuoteStateChangeOpen(true);
    setQuoteStateChangeId(quoteId);
    setQuoteStateChangeNewState(newState);
  };

  const closeModal = () => {
    toggleBlackOut();
    setIsModalQuoteStateChangeOpen(false);
  };

  const changeQuoteState = async () => {
    let isDelivered = false;
    let isWaiting = false;

    switch (quoteStateChangeNewState) {
      case 'Non commandé':
        isWaiting = false;
        isDelivered = false;
        break;
      case 'En cours de commande':
        isWaiting = true;
        isDelivered = false;
        break;
      case 'Livré':
        isWaiting = false;
        isDelivered = true;
        break;
    }

    try {
      await updateQuote(parseInt(dealId, 10), quoteStateChangeId, isWaiting, isDelivered);
      await syncData();

      openToast(true, "L'état de la commande a été actualisé");
    } catch (e) {
      openToast(false, 'Erreur modification commande. Veuillez réessayer');
    }
  };

  const handleChangeStep = async (index: number): Promise<void> => {
    if (currentStep !== index) {
      setCurrentStep(index);

      try {
        await updateDealOrderStepNumber(parseInt(dealId, 10), index);
      } catch (e) {
        setCurrentStep(currentStep);
        openToast(false, 'Erreur modification étape. Veuillez réessayer');
      }
    }
  };

  let noQuoteHardware;
  let noQuoteVirtual;
  if (dataQuoteHardware && dataQuoteHardware.length === 0) {
    noQuoteHardware = <span>Aucun produit pour cette affaire.</span>;
  }
  if (dataQuoteVirtual && dataQuoteVirtual.length === 0) {
    noQuoteVirtual = <span>Aucun abonnement pour cette affaire.</span>;
  }

  let viewName = ' ';
  switch (selectedView) {
    case 1:
      viewName = 'Produit';
      break;
    case 2:
      viewName = 'Service';
      break;
  }

  return (
    <div id='appView' className='div-entity appProd'>
      <SubNavBar goBack={history.goBack} title='Production' />

      <div id='appViewContent'>
        <Timeline onChangeStep={handleChangeStep} currentStep={currentStep} />

        <div className='helper helper-panel-legend'>
          <span className='helper-label-legend lvl2'>Action requise</span>
          <span className='helper-label-legend lvl1'>En cours</span>
        </div>

        <div className='timeline menu'>
          <div className='timeline-flex'>
            <div
              onClick={() => setSelectedView(1)}
              className={'prep-step-number ' + (selectedView === 1 ? 'selected' : '')}
            >
              <Box width='15px !important' clone>
                <img alt='icon' src={hardwareIcon} />
              </Box>
            </div>
            <div
              onClick={() => setSelectedView(2)}
              className={'prep-step-number ' + (selectedView === 2 ? 'selected' : '')}
            >
              <Box width='15px !important' clone>
                <img alt='icon' src={virtualIcon} />
              </Box>
            </div>
          </div>
        </div>
        <div className='timeline-step-name'>
          <h3>{viewName}</h3>
        </div>
        {selectedView == 1 &&
          (dataQuoteHardware ? (
            dataQuoteHardware.map((quote) => (
              <QuoteHardware
                quote={quote}
                stockQuantity={getStockQuantity(quote.productReference?.id)}
                key={quote.id}
              />
            ))
          ) : (
            <li className='list-group-item'>Chargement...</li>
          ))}
        {selectedView == 1 && noQuoteHardware}
        {selectedView == 2 &&
          (dataQuoteVirtual ? (
            dataQuoteVirtual.map((quote) => (
              <QuoteVirtual quote={quote} onQuoteChange={openModalChangeQuoteState} key={quote.id} />
            ))
          ) : (
            <li className='list-group-item'>Chargement...</li>
          ))}
        {selectedView == 2 && noQuoteVirtual}
      </div>

      <ModalConfirm
        className='myModal'
        modalText={textModal}
        isOpen={isModalQuoteStateChangeOpen}
        onSubmit={changeQuoteState}
        onClose={closeModal}
        onCancel={closeModal}
      ></ModalConfirm>
    </div>
  );
};

export default AppProduction;
